import { Component, OnInit } from '@angular/core';
import * as QuoteOptions from '../select-options-quote';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import * as Options from '../../work-orders/select-options';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ContactAutocompleteResult, ContactAutocompleteService } from '../../services/contacts/contact-autocomplete.service';

@Component({
  selector: 'app-quote-creator',
  templateUrl: './quote-creator.component.html',
  styleUrls: ['./quote-creator.component.scss']
})
export class QuoteCreatorComponent implements OnInit {

  submittedQuoteDetailsForm: boolean = false;
  quote_details_form: FormGroup =  this.fb.group({
    customer_contact_uuid: [''],
    customer_name: [''],
    rate_method: ['', Validators.required],
    partial_or_full: ['', Validators.required],
    shipment_type: ['', Validators.required],
    equipment_type: ['', Validators.required],
    equipment_option: [''],
    load_length: [0.0, Validators.min(0)],
    load_start: ['1970-01-01'],
    load_end: ['1970-01-01'],
    quote_start: ['1970-01-01'],
    quote_expiry: ['1970-01-01'],
    contact_person: [''],
    sales_person: ['', Validators.required],
    note: [''],
    order_scope: ['', Validators.required],
    origin: this.fb.group({
        city: [''],
        region: [''],
        postal_code: ['', [postalCodeCAorUSValidator()]]
      },
      { validators: [postalCodeOrCityRegionValidator()]}
    ),
    destination: this.fb.group({
        city: [''],
        region: [''],
        postal_code: ['', [postalCodeCAorUSValidator()]]
      },
      {validators: [postalCodeOrCityRegionValidator()]}
    )
  })

  values= []; 
  service_charge_info: FormGroup = this.fb.group({
    service_list: this.fb.array([
      this.fb.group({
        services: [''],
        service_types: ['']
      })
    ]),
  })

  palletForm : FormGroup = new FormGroup({
    palletList: new FormArray([])
  })

  counter: number = 1;
  salesPersonList: string[] = [];

  palletListArray() {
    return this.palletForm.get('palletList') as FormArray
  }

  getOrderScope() {
    return QuoteOptions.ORDER_SCOPE;
  }

  constructor(private fb: FormBuilder, private http: HttpClient, private contactSvc: ContactAutocompleteService) { }

  ngOnInit(): void {
    this.palletListArray().push(this.getPalletFields());

    this.getSales().subscribe(data => this.salesPersonList = data);
  }

  getPalletFields(): FormGroup {
    return new FormGroup({
      numberOfPallets: new FormControl(''),
      palletLength: new FormControl(''),
      palletWidth: new FormControl(''),
      palletHeight: new FormControl(''),
      palletWeight: new FormControl('')
    })
  }

  getServices() {
    return QuoteOptions.SERVICE_CHARGES;
  }

  getServiceType(service: string): string[] {
    let serviceTypes = [''];

    if (service === 'Accessorial Service') {
      serviceTypes = Options.ACCESSORIAL_TYPE;
    }
    else if (service === 'Surcharge Service') {
      serviceTypes = Options.SURCHARGE_TYPE;
    }
    else if (service === 'Tradeshow Service') {
      serviceTypes = Options.TRADESHOW_TYPE;
    }
    else if (service === 'Trailer Build Service') {
      serviceTypes = Options.TRAILER_BUILD_TYPE;
    }
    else if (service === 'Customs Service') {
      serviceTypes = Options.CUSTOMS_TYPE;
    }
    else if (service === 'Delivery Service') {
      serviceTypes = Options.DELIVERY_TYPE;
    }
    else if (service === 'Pickup Service') {
      serviceTypes = Options.PICKUP_TYPE;
    }
    else {
      serviceTypes = Options.LABOURER_TYPE;
    }

    return serviceTypes;
  }

  get service_list() {
    return this.service_charge_info.controls["service_list"] as FormArray;
    // return this.financial_info.get('note_list') as FormArray;
  }

  addService() {
    const sub_service_form = this.fb.group({
      services: [''],
      service_types: ['']
    });
    this.service_list.push(sub_service_form);
  }

  deleteService(index: number) {
    this.service_list.removeAt(index);
  }

  removePallet() {
    const lastIndex = this.values.length - 1;
    // this.values.slice(lastIndex);
    this.palletListArray().removeAt(lastIndex)
    this.counter = this.counter - 1;
  }

  addPallet() {
    this.palletListArray().push(this.getPalletFields());
    this.counter = this.counter + 1
  }

  getSales(): Observable<string[]> {
    const url = `/api/quotes/quotes.php`;
    const params = {
      name: 'salesPerson'
    }
    return this.http.get<any[]>(url, { params }).pipe(
      map(data => {
        return data.map(item => `${item.first_name} ${item.last_name} - ${item.email_address}`);
      })
    );
  }

  get customerNameControl(){
    return this.quote_details_form.get('customer_name') as FormControl;
  }
  
  onCustomerSelected(opt: ContactAutocompleteResult): void {
    this.quote_details_form.patchValue({
      customer_contact_uuid: opt.value,
      customer_name: opt.label
    });
  }

  searchDetailQuotes(){
    this.submittedQuoteDetailsForm = true;

    if(this.quote_details_form.invalid){
      this.quote_details_form.markAllAsTouched();
      return;
    }

    const value = this.quote_details_form.value;
    console.log(value);
  }
}

export const postalCodeOrCityRegionValidator = (): ValidatorFn => {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!group || !group.get) return null;

    const postalCode = group.get('postal_code')?.value;
    const city = group.get('city')?.value;
    const region = group.get('region')?.value;

    const hasPostalCode = !!postalCode;
    const hasCity = !!city;
    const hasRegion = !!region;

    // If postal code is filled → city & region NOT required
    if (hasPostalCode) {
      return null;
    }

    // If postal code is NOT filled → city AND region required
    if (!hasCity || !hasRegion) {
      return { cityRegionRequired: true };
    }

    return null;
  };
};

export function postalCodeCAorUSValidator(): ValidatorFn {
  // Canada: A1A 1A1 (allow optional space)
  // Excludes D,F,I,O,Q,U as first letter; excludes D,F,I,O,Q,U in third letter; allows W,Z in first per modern rules
  const ca = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\s?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

  // US: 12345 or 12345-6789
  const us = /^\d{5}(-\d{4})?$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;

    // allow untouched default
    if (raw === null || raw === undefined) return null;

    const value = String(raw).trim();

    // allow empty string
    if (value === '') return null;

    if (ca.test(value) || us.test(value)) return null;

    return { postalCodeInvalid: true };
  };
}
